/** Pending customer decisions. Shared by the feature and navigation indicator. */
/**
 * Kho & LOT — chốt 20/09/2026 theo chuẩn (nhận theo đơn mua, tách theo LOT, không nhận vượt số đặt; số lô nhà cung cấp; hàng mới nhận
 * chờ kiểm; phiếu đã nhập không sửa mà đảo; tồn đầu kỳ từ phiếu đếm; quyền theo ô tick), khách bác lại được. Không còn nhãn — xem
 * components/warehouse/WarehouseRules.tsx. Giữ bộ mã để tra lịch sử quyết định.
 */
export const RECEIPT_RULES = {
  identity: 'W-R01', allocation: 'W-R02', units: 'W-R03', process: 'W-R04',
  quarantine: 'W-R06', legacy: 'W-R09', access: 'W-R08',
} as const;

export const IQC_RULES = {criteria:'IQC-R01',allocation:'IQC-R02',documents:'IQC-R03',arrival:'IQC-R04',access:'IQC-R05'} as const;

/**
 * Biến động kho — chốt 20/09/2026 theo chuẩn (chuyển lô một bước trong kho / hai bước khác kho; chỉ chuyển hàng dùng được; giữ hàng chặn
 * cứng theo lô và vị trí; kiểm kê theo ảnh chụp, áp số cần ô Duyệt; trừ kho khi hàng rời kho; hàng trả theo phiếu giao gốc), khách bác lại
 * được. Không còn nhãn — xem components/warehouse/StockMoveRules.tsx. Giữ bộ mã để tra lịch sử quyết định.
 */
export const TRANSFER_RULES={timing:'MOVE-R01',quality:'MOVE-R02',authority:'MOVE-R03'} as const;
export const RESERVATION_RULES={hold:'RSV-R01',consume:'RSV-R02',scope:'RSV-R03'} as const;
export const COUNT_RULES={snapshot:'CNT-R01',hold:'CNT-R02',opening:'OPEN-R01'} as const;
export const SALES_ISSUE_RULES={moment:'SALE-R01',rma:'RMA-R01'} as const;
/**
 * Hậu mãi — anh Toàn chốt 19/09/2026 theo chuẩn, khách bác lại được: TKT-R01 hồ sơ không phải chứng từ kho hay tiền (hàng trả nhận ở
 * Biến động kho, Chất lượng quyết định hàng trả, giảm công nợ ở phía Hóa đơn); TKT-R02 một đường nhận hàng trả, trạng thái có Mở lại khi
 * khách không đồng ý (migration 0091), hạn trả lời khách tuỳ chọn, quyền theo ô tick. Không còn nhãn — xem ServiceTicketsPage.tsx.
 */
// export const TICKET_RULES={stock:'TKT-R01',link:'TKT-R02'} as const;
/**
 * Khiếu nại nhà cung cấp — chốt 20/09/2026 theo chuẩn (SAP QM Q2 / SCAR, vendor debit memo), khách bác lại được: SCL-R01 duyệt
 * số tiền là quyết định tiền — ô Duyệt, người lập không tự duyệt, sinh phiếu ghi nợ nháp, đóng sau khi ghi sổ; SCL-R02 nhà cung cấp phản
 * hồi trên cổng hoặc nhân viên ghi nhận, không đồng ý thì điều chỉnh và gửi lại; sửa sau khi đã có phản hồi thì phải gửi lại rồi mới duyệt.
 * Không còn nhãn — xem SupplierClaimsPage.tsx.
 */
// export const SUPPLIER_CLAIM_RULES={money:'SCL-R01',response:'SCL-R02'} as const;

/** Định mức vật tư — BOM-R01…R03 CHỐT 20/09/2026, cùng hai quy tắc mới (scope: không làm BOM riêng theo khách; authority: ai
 * được làm gì). Chữ ở i18n/boms.ts, mục gập ở components/production/BomRules.tsx. Giữ mã quy tắc để tra ngược từ nhật ký
 * quyết định; nav.ts không còn gắn nhãn vàng cho mục này. */
export const BOM_RULES={basis:'BOM-R01',allowance:'BOM-R02',revision:'BOM-R03'} as const;

/** Quy trình công đoạn — ROUTE-R01…R04 CHỐT 20/09/2026, cùng một quy tắc mới (subcontract: mỗi công đoạn tự khai làm
 * trong xưởng hay thuê ngoài). Chữ ở i18n/routings.ts, mục gập ở components/production/RoutingRules.tsx. */
export const ROUTING_RULES={source:'ROUTE-R01',timing:'ROUTE-R02',qc:'ROUTE-R03',authority:'ROUTE-R04'} as const;

/**
 * Yêu cầu mua hàng — anh Toàn chốt 19/09/2026 theo chuẩn, khách bác lại được: PR-R01 ai có ô Tạo lập (tay hoặc từ MRP), không giá;
 * PR-R02 người có ô Duyệt duyệt cả yêu cầu, người lập không tự duyệt, không hạn mức tiền (tiền duyệt ở đơn mua); PR-R03 xong khi đã đặt
 * đủ, mua hàng đóng. Không còn nhãn chờ xác nhận — xem apps/web/src/components/requisitions/RequisitionRules.tsx.
 */
// export const REQUISITION_RULES={need:'PR-R01',approval:'PR-R02',closure:'PR-R03'} as const;

/**
 * Đơn bán hàng — anh Toàn chốt 19/09/2026 theo chuẩn ERP, khách bác lại được: SO-R01 PI là cam kết, đơn bán hàng là nguồn nhu cầu duy
 * nhất của MRP / lệnh sản xuất, một PI một đơn; SO-R02 đơn mới chờ xác nhận, người có ô "Duyệt" xác nhận kèm căn cứ, cần ngày dự kiến
 * xuất; SO-R03 đổi ngày có lịch sử, sửa PI thì huỷ đơn trước, đóng là quyết định kế hoạch; SO-WAVE-R01 giao nhiều đợt bằng lịch giao
 * trên đơn và phiếu giao từng phần. Không còn nhãn chờ xác nhận — xem apps/web/src/components/salesOrders/SalesOrderRules.tsx.
 */
// export const SO_RULES={source:'SO-R01',review:'SO-R02',amendment:'SO-R03'} as const;

/** Shop-floor execution (Đợt A): reporting basis, output→progress link, LOT ownership, close reconciliation, BOM input coverage. */
export const EXECUTION_RULES={reporting:'EXEC-R01',output:'EXEC-R02',lot:'EXEC-R03',closing:'EXEC-R04',coverage:'EXEC-R05'} as const;

/** Quality specs + IPQC/FQC: limits, sampling, acceptance authority, rework. */
export const SPEC_RULES={limits:'SPEC-R01',acceptance:'SPEC-R02',rework:'SPEC-R03'} as const;
export const SUBCONTRACT_RULES={ownership:'SUB-R01',receive:'SUB-R02',qc:'SUB-R03',stages:'SUB-R04'} as const;
export const NCR_RULES={source:'NCR-R01',close:'NCR-R02',assessment:'NCR-R03'} as const;
export const GL_RULES={mapping:'GL-R01',period:'GL-R02',matching:'AP-R01',costing:'COST-R01'} as const;
export const KPI_RULES={source:'KPI-R01',forecast:'KPI-R02'} as const;
/** Khách chốt 15/09/2026 mở cổng nhà cung cấp — không còn nhãn chờ xác nhận. Giữ mã quy tắc để tra lại lịch sử. */
/**
 * Đơn vị & bảng giá — anh Toàn chốt 19/09/2026 theo chuẩn ERP, khách bác lại được: UOM-R01 quy đổi khai riêng từng mã (gợi ý Gross = 144,
 * K = 1.000); UOM-R02 giá gợi ý: thoả thuận với khách → bậc số lượng → dưới MOQ → giá danh mục, MOQ theo từng mã, không tự đổi ngoại
 * tệ; UOM-R03 chỉ admin duyệt, hiệu lực từ lúc duyệt, chứng từ đã lập giữ nguyên. Không còn nhãn chờ xác nhận.
 */
// export const UOM_RULES={conversion:'UOM-R01',pricing:'UOM-R02',approval:'UOM-R03'} as const;
// export const PORTAL_RULES={scope:'PORTAL-R01'} as const;
/** Quét & tem — DEV-R01 (mô phỏng không phải máy thật) và DEV-R02 (hiệu chuẩn cân) CHỐT 20/09/2026, cùng hai quy tắc mới
 * (mỗi việc đi qua đúng màn; tem in được gì in nấy). Chữ ở i18n/devices.ts, mục gập ở components/scan/ScanRules.tsx. Giữ mã
 * quy tắc ở đây để tra ngược từ nhật ký quyết định; nav.ts không còn gắn nhãn vàng cho mục này. */
export const DEVICE_RULES={channel:'DEV-R01',calibration:'DEV-R02'} as const;

/** Cơ hội bán hàng (màn đã ẩn 16/09/2026). SO-WAVE-R01 (lịch giao từng đợt) chốt 19/09/2026 cùng Đơn bán hàng — xem SO_RULES. */
export const OPPORTUNITY_RULES={pipeline:'CRM-R01'} as const;

/**
 * Quy trình thường (29/10/2026) — FLOW-R01: các bước theo chuẩn bán hàng → thu tiền vì khách chưa có tờ quy trình như tờ "P 流程"; anh Toàn
 * đồng ý, CHỜ KHÁCH XÁC NHẬN. Anh Toàn chốt cùng ngày (bản 1.1.83): KHÔNG hiện nhãn ở màn hay ở menu — anh tự hỏi khách. Giữ mã ở đây để
 * tra ngược từ nhật ký quyết định và sổ câu hỏi; nav.ts không gắn nhãn vàng cho mục này (như DEVICE_RULES).
 */
export const ORDER_PROCESS_RULES = { steps: 'FLOW-R01' } as const;

/**
 * Vị trí kho (YC-07 phần 1) — chốt 30/10/2026 theo chuẩn ERP (SAP EWM storage bin / Odoo location), khách bác lại được: BIN-R01 một vị
 * trí chứa nhiều mã hàng, nhiều lô, không giới hạn sức chứa; BIN-R02 vùng hàng là chữ tự do để xem và lọc; BIN-R03 chỉ kiểm vị trí ở kho
 * đã có danh mục, mã chuẩn hoá chữ hoa, vị trí cũ không sửa. Còn nhãn Chờ khách xác nhận — xem WarehouseLocationsPage.tsx.
 */
export const BIN_RULES = { multi: 'BIN-R01', zone: 'BIN-R02', enforce: 'BIN-R03' } as const;
